import { render, staticRenderFns } from "./DInputEditor.vue?vue&type=template&id=f3880a50&"
import script from "./DInputEditor.vue?vue&type=script&lang=js&"
export * from "./DInputEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports